import { ChangeEvent, useEffect } from "react";
import { Box, Grid, MenuItem } from "@mui/material";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { InputsConfirmationContract } from "src/Contexts/ReportProduction/ReportsProductionTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import { ComponentPrivate } from "src/Pages/components/ComponentPrivate/ComponentPrivate";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { SelectedFiliaisAutoCompletedGeneric } from "src/Pages/components/AutoCompleted/Multiple/SelectedFiliais";
import { DrawerFilterReport } from "src/Pages/components/DrawerFilterReport/DrawerFilterReport";

import { AutoCompleteCorretorGeneric } from "../../../../../../components/AutoCompleted/AutoCompleteCorretor";
import { SelectedAdministradorasGeneric } from "../../../../../../components/AutoCompleted/Multiple/SelectedAdministradoras";
import { SelectedModalidadesGeneric } from "../../../../../../components/AutoCompleted/Multiple/SelectedModalidades";
import { SelectedOperadorasGeneric } from "../../../../../../components/AutoCompleted/Multiple/SelectedOperadoras";

import { UseReportParcelasAbertas } from "./Form/Hooks/UseReportParcelasAbertas";
import { apenasNumeros } from "src/shared/Utils/FormatMoney";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";

export const DrawerFilterParcelasAbertas = () => {
  const { setInputsConfirmationContract, inputsConfirmationContract } =
    useContextReportsProduction();
  const { setActive_incluir, active_incluir } = useConfigPageContext();

  const { handleSubmit } = UseReportParcelasAbertas();
  const { resetInputs } = useResetInputs(true);
  const { userPerfil } = useAuthContext();

  useEffect(() => setActive_incluir(true), [active_incluir]);

  const handleChange =
    (
      prop: keyof InputsConfirmationContract,
      option?: "limitNumber" | "apenasNumero",
    ) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "limitNumber") {
          if (event.target.value.length <= 5) {
            setInputsConfirmationContract({
              ...inputsConfirmationContract,
              [prop]: event.target.value,
            });
          }
        } else if (option === "apenasNumero") {
          if (event.target.value.length <= 5) {
            setInputsConfirmationContract({
              ...inputsConfirmationContract,
              [prop]: apenasNumeros(event.target.value),
            });
          }
        } else {
          setInputsConfirmationContract({
            ...inputsConfirmationContract,
            [prop]: event.target.value,
          });
        }
      };

  return (
    <DrawerFilterReport onClear={resetInputs} onApply={handleSubmit} >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          "& .MuiAutocomplete-root": { margin: 0 },
        }}
      >
        <Box>
          <DividerCore title="Datas" sxStyle={{ margin: "0 0 16px 0" }} />

          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={6}>
              <AppTextField
                fullWidth
                label="Data de vencimento Início"
                type="date"
                variant="outlined"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={inputsConfirmationContract?.start_date_due}
                onChange={handleChange("start_date_due")}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AppTextField
                fullWidth
                label="Data de vencimento Fim"
                type="date"
                variant="outlined"
                sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                value={inputsConfirmationContract?.end_date_due}
                onChange={handleChange("end_date_due")}
              />
            </Grid>
          </Grid>
        </Box>

        <ComponentPrivate isView={userPerfil?.type_user !== "PRODUCER"}>
          <Box>
            <DividerCore title="Parcelas" sxStyle={{ margin: "0 0 16px 0" }} />
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={6} sm={6} md={6}>
                <AppTextField
                  fullWidth
                  select
                  id="Numero_da_parcela"
                  label="Parcela igual a ?"
                  variant="outlined"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract?.installmentNumberOperator}
                  onChange={handleChange("installmentNumberOperator")}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  <MenuItem value="EQUAL">Igual</MenuItem>
                  <MenuItem value="GREATER">Maior que</MenuItem>
                  <MenuItem value="LESS">Menor que</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <AppTextField
                  fullWidth
                  label="Número da parcela"
                  variant="outlined"
                  type="number"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract.installmentNumber}
                  disabled={
                    inputsConfirmationContract?.installmentNumberOperator ===
                    "ALL"
                  }
                  onChange={handleChange("installmentNumber", "apenasNumero")}
                />
              </Grid>
            </Grid>
          </Box>
        </ComponentPrivate>

        <Box sx={{ mb: "24px" }}>
          <DividerCore
            title="Operadoras e Planos"
            sxStyle={{ margin: "0 0 16px 0" }}
          />
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={4}>
              <Box>
                <SelectedOperadorasGeneric
                  fullWidth
                  label="Operadoras"
                  variant="outlined"
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <SelectedModalidadesGeneric
                  fullWidth
                  label="Modalidades"
                  variant="outlined"
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0 } }}>
                <SelectedAdministradorasGeneric
                  fullWidth
                  label="Administradoras"
                  variant="outlined"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <ComponentPrivate isView={userPerfil?.type_user !== "PRODUCER"}>
          <Box>
            <DividerCore
              title="Parcelas Vitalício"
              sxStyle={{ margin: "0 0 16px 0" }}
            />
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={6} sm={6} md={3}>
                <AppTextField
                  fullWidth
                  select
                  id="is_vitalicio_corretora"
                  label="Vitalício Corretora"
                  variant="outlined"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract?.is_vitalicio_corretora}
                  onChange={handleChange("is_vitalicio_corretora")}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  <MenuItem value="TRUE">Sim</MenuItem>
                  <MenuItem value="FALSE">Não</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <AppTextField
                  fullWidth
                  select
                  id="is_vitalicio_corretor"
                  label="Vitalício Corretor"
                  variant="outlined"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract?.is_vitalicio_corretor}
                  onChange={handleChange("is_vitalicio_corretor")}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  <MenuItem value="TRUE">Sim</MenuItem>
                  <MenuItem value="FALSE">Não</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <AppTextField
                  fullWidth
                  select
                  id="is_vitalicio_supervisor"
                  label="Vitalício Supervisor"
                  variant="outlined"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract?.is_vitalicio_supervisor}
                  onChange={handleChange("is_vitalicio_supervisor")}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  <MenuItem value="TRUE">Sim</MenuItem>
                  <MenuItem value="FALSE">Não</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <AppTextField
                  fullWidth
                  select
                  id="is_vitalicio_gerente"
                  label="Vitalício Gerente"
                  variant="outlined"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract?.is_vitalicio_gerente}
                  onChange={handleChange("is_vitalicio_gerente")}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  <MenuItem value="TRUE">Sim</MenuItem>
                  <MenuItem value="FALSE">Não</MenuItem>
                </AppTextField>
              </Grid>
            </Grid>
          </Box>
        </ComponentPrivate>

        <ComponentPrivate isView={userPerfil?.type_user !== "PRODUCER"}>
          <Box>
            <DividerCore title="Produtor" sxStyle={{ margin: "0 0 16px 0" }} />
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={6} sm={6} md={6}>
                <AppTextField
                  fullWidth
                  select
                  label="Produtor *"
                  variant="outlined"
                  sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
                  value={inputsConfirmationContract?.type_report}
                  onChange={handleChange("type_report")}
                >
                  <MenuItem value="ALL">Todos</MenuItem>
                  <MenuItem value="UNIQUE">Por Produtor</MenuItem>
                </AppTextField>
              </Grid>
              <Grid item xs={6} sm={5} md={6}>
                <Box
                  sx={{ "& .MuiAutocomplete-root": { mt: 0, mb: 0, mr: 1 } }}
                >
                  <AutoCompleteCorretorGeneric
                    fullWidth
                    disabled={inputsConfirmationContract.type_report === "ALL"}
                    label="Corretor *"
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box>
            <DividerCore title="Filiais" sxStyle={{ margin: "0 0 16px 0" }} />
            <Grid item xs={12} sm={6}>
              <SelectedFiliaisAutoCompletedGeneric
                fullWidth
                label="Filiais"
                variant="outlined"
              />
            </Grid>
          </Box>
        </ComponentPrivate>
      </Box>
    </DrawerFilterReport>
  );
};
